import { type WheelEvent as ReactWheelEvent } from "react";
import axios from "axios";

export const preventInputScroll = (e: UIEvent | WheelEvent | ReactWheelEvent): void => {
    if(
        document.activeElement &&
        document.activeElement === e.target &&
        document.activeElement.tagName === "INPUT" &&
        (document.activeElement as HTMLInputElement).type === "number"
    ) {
        e.preventDefault();
    }
};

/**
 * Determine if the provided value is an abort error
 */
export const isAbortError = (e: unknown): boolean => {
    return e instanceof DOMException && e.name === "AbortError" || axios.isCancel(e);
};
